import styled from 'styled-components';

const Headline = styled.h2`
  ${({ theme }) => (`
    color: ${theme.colors.text};
  `)};
`;

export const Editorial = styled(Headline)`
  ${({ theme }) => (`${theme.headline.editorial.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.editorial.fontSize};
  line-height: ${({ theme }) => theme.headline.editorial.lineHeight};
`;
export const Display1 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.display1.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.display1.fontSize};
  line-height: ${({ theme }) => theme.headline.display1.lineHeight};
`;
export const Display2 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.display2.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.display2.fontSize};
  line-height: ${({ theme }) => theme.headline.display2.lineHeight};
`;
export const Display3 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.display3.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.display3.fontSize};
  line-height: ${({ theme }) => theme.headline.display3.lineHeight};
`;
export const H1 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h1.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h1.fontSize};
  line-height: ${({ theme }) => theme.headline.h1.lineHeight};
`;
export const H1Semibold = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h1Semibold.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h1Semibold.fontSize};
  line-height: ${({ theme }) => theme.headline.h1Semibold.lineHeight};
`;
export const H2 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h2.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h2.fontSize};
  line-height: ${({ theme }) => theme.headline.h2.lineHeight};
`;
export const H3 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h3.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h3.fontSize};
  line-height: ${({ theme }) => theme.headline.h3.lineHeight};
`;
export const H4 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h4.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h4.fontSize};
  line-height: ${({ theme }) => theme.headline.h4.lineHeight};
`;
export const H5 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h5.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h5.fontSize};
  line-height: ${({ theme }) => theme.headline.h5.lineHeight};
`;
export const H5Semibold = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h5Semibold.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h5Semibold.fontSize};
  font-weight: ${({ theme }) => theme.headline.h5Semibold.fontWeight};
  line-height: ${({ theme }) => theme.headline.h5Semibold.lineHeight};
`;
export const H6 = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h6.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h6.fontSize};
  line-height: ${({ theme }) => theme.headline.h6.lineHeight};
`;
export const H6Semibold = styled(Headline)`
  ${({ theme }) => (`${theme.headline.h6Semibold.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.h6Semibold.fontSize};
  font-weight: ${({ theme }) => theme.headline.h6Semibold.fontWeight};
  line-height: ${({ theme }) => theme.headline.h6Semibold.lineHeight};
`;
export const QuoteSmall = styled(Headline)`
  ${({ theme }) => (`${theme.headline.quoteSmall.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.quoteSmall.fontSize};
  line-height: ${({ theme }) => theme.headline.quoteSmall.lineHeight};
`;

export const QuoteLarge = styled(Headline)`
  ${({ theme }) => (`${theme.headline.quoteLarge.fontFace}`)};
  font-size: ${({ theme }) => theme.headline.quoteLarge.fontSize};
  line-height: ${({ theme }) => theme.headline.quoteLarge.lineHeight};
`;
export const QuoteSmallWhite = styled(QuoteSmall)`
  color: ${({ theme }) => theme.colors.white};
`;
export const QuoteLargeWhite = styled(QuoteLarge)`
  color: ${({ theme }) => theme.colors.white};
`;